export default {
  title: 'Începeți',
  description: 'Pentru a încărca pagina curentă, trebuie să completați ghidul de început',
  button: 'Începeți',
};
